import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  fr: {
    common: {
      brand: "iTranspro",
      tagline: "L'excellence suisse au croisement de la technologie et de la mobilité",
      guarantee: "Société immatriculée en Suisse — Confidentiel & Certifié",
    },
    nav: { home: "Accueil", it: "Pôle Informatique", transport: "Pôle Transport", contact: "Contact & Devis" },
    home: {
      eyebrow: "iTranspro Sàrl — Genève",
      title1: "Deux mondes.",
      title2: "Une exigence suisse.",
      subtitle: "Solutions logicielles, cybersécurité et mobilité d'exception. Choisissez votre univers.",
      it: {
        label: "Pôle 01 — Informatique",
        title: "SaaS & Cybersécurité",
        desc: "Développement de logiciels sur-mesure, audits de sécurité et tests d'intrusion aux standards suisses.",
        cta: "Explorer le pôle IT",
        tags: ["Développement SaaS", "Pentest", "SOC 24/7"],
      },
      transport: {
        label: "Pôle 02 — Transport",
        title: "Transport VIP & Véhicules",
        desc: "Chauffeur privé exécutif, location de prestige et achat/vente de véhicules haut de gamme.",
        cta: "Explorer le pôle Transport",
        tags: ["Chauffeur privé", "Location", "Achat / Vente"],
      },
      marquee: ["GENÈVE", "ZÜRICH", "SAAS", "CYBERSÉCURITÉ", "CHAUFFEUR PRIVÉ", "PENTEST", "LOCATION PRESTIGE", "GSTAAD", "ST. MORITZ", "LAUSANNE"],
      aboutEyebrow: "À propos",
      aboutTitle: "Une maison suisse, deux expertises d'exception",
      aboutText: "Basée à Genève, iTranspro Sàrl réunit deux savoir-faire d'excellence : l'ingénierie logicielle et la cybersécurité d'une part, le transport de personnes et l'automobile de prestige d'autre part. Une même exigence : la précision suisse, la discrétion et la qualité de service.",
      stats: [
        { v: "24h", l: "Délai de réponse" },
        { v: "2", l: "Pôles d'expertise" },
        { v: "100%", l: "Confidentialité suisse" },
      ],
      aboutCta: "Discuter de votre projet",
    },
    it: {
      badge: "Pôle 01 — Informatique",
      hero1: "Logiciels.",
      hero2: "Sécurité. Précision.",
      heroSub: "Nous concevons et exploitons des solutions SaaS sur-mesure et nous sécurisons vos systèmes : audits, tests d'intrusion et supervision continue, aux standards suisses.",
      heroCta: "Estimer un projet",
      heroCtaSecondary: "Nos expertises",
      stats: [
        { v: "3", l: "Solutions SaaS en production" },
        { v: "24/7", l: "Disponibilité assurée" },
        { v: "100%", l: "Sur-mesure" },
      ],
      refTitle: "Solutions conçues par nos soins",
      refSub: "Trois plateformes SaaS que nous avons développées et que nous exploitons au quotidien.",
      refs: [
        { name: "appel247.com", d: "Plateforme SaaS d'accueil téléphonique intelligent 24/7 : appels, réservations, commandes et paiements automatisés par IA.", url: "https://appel247.com" },
        { name: "noomadz.com", d: "Plateforme de voyage : locations d'hébergements et de véhicules, avec création d'itinéraires sur mesure.", url: "https://noomadz.com" },
        { name: "noorelbayen.com", d: "Plateforme éducative d'étude du Coran en contexte : sourates, hadiths et chronologies historiques sourcés.", url: "https://noorelbayen.com" },
      ],
      refVisit: "Visiter le site",
      servicesTitle: "Nos expertises",
      servicesSub: "Du code au SOC : une chaîne de valeur complète.",
      services: [
        { t: "Développement SaaS sur-mesure", d: "Architectures cloud résilientes, API REST/GraphQL haute performance et exploitation de vos applications en mode SaaS.", tags: ["Cloud", "API", "DevOps"] },
        { t: "Audits & Pentesting", d: "Tests de pénétration web, mobiles et réseaux menés par des experts certifiés, conformes OWASP.", tags: ["Red Team", "OWASP", "OSINT"] },
        { t: "Portage salarial & placement de développeurs", d: "Nous mettons à disposition des entreprises nos développeurs expérimentés pour renforcer vos équipes, en régie ou en portage salarial : recrutement, administration et conformité suisse pris en charge.", tags: ["Staffing", "Régi", "Recrutement"] },
        { t: "Supervision & SOC 24/7", d: "Surveillance en temps réel de vos infrastructures avec détection et réponse aux incidents.", tags: ["SIEM", "Monitoring", "Réponse"] },
        { t: "Conformité LPD & RGPD", d: "Accompagnement vers la conformité des données bancaires, médicales et personnelles selon la législation suisse et européenne.", tags: ["LPD", "RGPD", "ISO 27001"] },
      ],
      terminal: [
        "$ nmap -sS --top-ports 1000 cible.ch",
        "[+] 443/tcp open  https",
        "$ ./pentest --scope webapp --mode stealth",
        "[+] Vulnérabilité détectée — endpoint /api/v1/users",
        "[+] Rapport généré : criticité HAUTE",
        "$ conformité LPD : OK",
      ],
      estimator: {
        title: "Estimateur de projet",
        desc: "Obtenez une première fourchette de budget et de délai pour votre projet.",
        serviceLabel: "Type de prestation",
        services: ["Pentest applicatif web", "Pentest infrastructure", "Développement SaaS sur-mesure", "Audit & conformité ISO 27001 / LPD"],
        scopeLabel: "Périmètre — applications / IP",
        unit: "éléments",
        critLabel: "Criticité",
        crit: ["Standard", "Élevée", "Critique — banque / santé"],
        result: "Estimation indicative",
        weeks: "semaines",
        note: "Estimation non contractuelle — affinée après analyse de vos besoins.",
        cta: "Demander un devis détaillé",
      },
      ctaTitle: "Votre prochain audit commence ici.",
      ctaSub: "Réponse de nos ingénieurs sous 24h ouvrées.",
      ctaBtn: "Lancer la discussion",
    },
    transport: {
      badge: "Pôle 02 — Transport & Véhicules",
      hero1: "La route.",
      hero2: "En première classe.",
      heroSub: "Chauffeur privé exécutif, location de véhicules de prestige et courtage automobile. Une mobilité d'exception entre Genève, Zurich et les Alpes.",
      cta1: "Calculer un trajet",
      cta2: "Nous contacter",
      servicesTitle: "Nos services",
      servicesSub: "Chaque trajet, chaque véhicule, chaque détail — maîtrisé.",
      services: [
        { t: "Chauffeur privé VIP", d: "Transferts aéroport (GVA/ZRH), congrès et déplacements d'affaires avec chauffeurs professionnels et discrets." },
        { t: "Location de prestige", d: "AMG A 45 S, Tesla Model Y, AMG CLA et BYD Seal U DM-i — à la journée ou en longue durée." },
        { t: "Achat / Vente & sourcing", d: "Courtage et expertise pour l'acquisition ou la cession de voitures de luxe et de collection." },
        { t: "Conciergerie & flottes", d: "Gestion de flottes d'entreprise, entretien et conciergerie automobile sur mesure." },
      ],
      fleetTitle: "Notre flotte de location",
      fleetSub: "Quatre véhicules d'exception, entretenus et disponibles à Genève.",
      fleetCta: "Découvrir la flotte",
      calculator: {
        title: "Calculateur de trajet & location",
        desc: "Un tarif indicatif en quelques secondes, confirmé à la réservation.",
        serviceLabel: "Prestation",
        services: ["Chauffeur privé", "Location de véhicule", "Achat / vente & sourcing"],
        routeLabel: "Trajet",
        routes: ["Genève Aéroport → Centre-ville", "Genève → Zurich", "Genève → Gstaad", "Genève → St. Moritz", "Zurich → Davos"],
        vehicleLabel: "Véhicule",
        vehicles: ["Mercedes-AMG A 45 S", "Tesla Model Y", "Mercedes-AMG CLA", "BYD Seal U DM-i"],
        daysLabel: "Durée",
        days: "jours",
        result: "Tarif indicatif",
        onRequest: "Sur devis personnalisé",
        note: "Tarif indicatif TTC — confirmé à la réservation.",
        cta: "Réserver / demander un devis",
      },
      ctaTitle: "Votre chauffeur vous attend.",
      ctaSub: "Disponibilité 7j/7 entre Genève, Zurich et les stations alpines.",
      ctaBtn: "Réserver maintenant",
    },
    rental: {
      title: "Location de prestige",
      sub: "Notre flotte propre, entretenue avec soin et disponible à Genève. À la journée, à la semaine ou en longue durée.",
      seats: "places",
      auto: "Automatique",
      cta: "Demander ce véhicule",
      note: "Chaque véhicule est livré propre, chargé ou plein fait, avec assistance 7j/7. Caractéristiques selon données constructeur ; tarifs sur devis selon durée et saison.",
      labels: { power: "Puissance", accel: "0 → 100 km/h", drivetrain: "Transmission", energy: "Énergie / conso.", gearbox: "Boîte", trunk: "Coffre", seats: "Places" },
      cars: [
        "Compacte au tempérament explosif de 421 ch : l'alliance parfaite de l'agilité urbaine et des sensations circuit.",
        "SUV 100% électrique polyvalent : grande autonomie, habitacle spacieux et pilotage d'avant-garde.",
        "Coupé 4 portes aux lignes sculpturales : élégance exécutive et réactivité sportive signées AMG.",
        "SUV hybride rechargeable de 330 ch : autonomie combinée généreuse et confort grand tourisme.",
      ],
    },
    contact: {
      title: "Contact & devis",
      desc: "Notre équipe basée à Genève répond à vos exigences sous 24h ouvrées.",
      name: "Nom & prénom / entreprise",
      email: "Adresse e-mail professionnelle",
      phone: "Téléphone (optionnel)",
      pole: "Pôle concerné",
      poleOptions: ["Pôle Informatique", "Pôle Transport & Véhicules", "Autre demande"],
      message: "Votre message / spécifications du projet",
      submit: "Envoyer la demande",
      sending: "Envoi en cours…",
      success: "Votre demande a bien été envoyée. Nous répondons sous 24h.",
      error: "Une erreur est survenue. Merci de réessayer.",
      required: "Ce champ est requis",
      invalidEmail: "Adresse e-mail invalide",
      tooShort: "Message trop court (10 caractères min.)",
      infoTitle: "iTranspro Sàrl",
      addr1: "30 Rue du Mail, 1205 Genève",
      ide: "IDE : CHE-177.971.181",
      emailLabel: "contact@itranspro.ch",
      phoneLabel: "+41 78 630 66 94",
    },
    footer: {
      desc: "Technologie & mobilité d'exception — une maison suisse, deux pôles d'expertise.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      rights: "Tous droits réservés.",
    },
    legal: {
      title: "Mentions légales",
      updated: "Dernière mise à jour : novembre 2026",
      sections: [
        { h: "Éditeur du site", p: "iTranspro Sàrl — société à responsabilité limitée (Sàrl) de droit suisse. Siège : 30 Rue du Mail, 1205 Genève, Suisse. Numéro IDE : CHE-177.971.181. Contact : contact@itranspro.ch." },
        { h: "Objet du site", p: "Le présent site a pour objet la présentation des activités d'iTranspro Sàrl : développement et exploitation de logiciels en mode SaaS, conseil en cybersécurité, portage salarial et placement de développeurs, transport professionnel de personnes, achat/vente et location de véhicules. Il met également à disposition un formulaire de contact ainsi que des estimateurs de prix et de délais purement indicatifs." },
        { h: "Propriété intellectuelle", p: "L'ensemble des contenus du site (textes, logo, graphismes, illustrations) est la propriété exclusive d'iTranspro Sàrl ou de ses partenaires. Toute reproduction, représentation ou utilisation, totale ou partielle, sans autorisation écrite préalable est interdite." },
        { h: "Responsabilité", p: "Les informations publiées le sont à titre indicatif ; iTranspro Sàrl s'efforce d'en garantir l'exactitude sans pouvoir l'assurer en permanence. Les estimations affichées sur le site sont non contractuelles. iTranspro Sàrl ne saurait être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site." },
        { h: "Droit applicable et juridiction", p: "Le présent site est soumis au droit suisse. Tout litige relatif à son utilisation est de la compétence exclusive des tribunaux du canton de Genève." },
      ],
    },
    privacy: {
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : novembre 2026",
      sections: [
        { h: "Responsable du traitement", p: "iTranspro Sàrl, 30 Rue du Mail, 1205 Genève, Suisse — IDE : CHE-177.971.181 — contact@itranspro.ch. La présente politique est établie conformément à la Loi fédérale sur la protection des données (LPD)." },
        { h: "Données collectées", p: "Lors de l'utilisation du formulaire de contact : nom, adresse e-mail, numéro de téléphone (facultatif), pôle concerné et contenu du message. Des données techniques de navigation (adresse IP, type de navigateur) peuvent être traitées pour assurer la sécurité du site." },
        { h: "Finalités et base légale", p: "Vos données sont utilisées uniquement pour répondre à vos demandes, établir des devis et gérer la relation commerciale (mesures précontractuelles et intérêt légitime). Elles ne sont jamais vendues ni partagées à des fins de marketing." },
        { h: "Durée de conservation", p: "Vos données sont conservées le temps nécessaire au traitement de votre demande, puis au maximum 24 mois en l'absence de relation commerciale, sauf obligation légale contraire." },
        { h: "Destinataires et transferts", p: "Les données sont traitées en Suisse et, le cas échéant, dans l'Union européenne par nos sous-traitants techniques (hébergement, envoi d'e-mails), liés par des obligations de confidentialité et de sécurité." },
        { h: "Vos droits", p: "Conformément à la LPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant vos données. Écrivez à contact@itranspro.ch. Vous pouvez également saisir le Préposé fédéral à la protection des données et à la transparence (PFPDT)." },
        { h: "Sécurité", p: "Nous appliquons des mesures techniques et organisationnelles appropriées (chiffrement TLS, accès restreint) pour protéger vos données contre tout accès non autorisé." },
      ],
    },
  },
  de: {
    common: {
      brand: "iTranspro",
      tagline: "Schweizer Spitzenleistung an der Schnittstelle von Technologie und Mobilität",
      guarantee: "In der Schweiz registriertes Unternehmen — Vertraulich & Zertifiziert",
    },
    nav: { home: "Start", it: "IT & Software", transport: "Transport & Fahrzeuge", contact: "Kontakt & Offerte" },
    home: {
      eyebrow: "iTranspro Sàrl — Genf",
      title1: "Zwei Welten.",
      title2: "Ein Schweizer Anspruch.",
      subtitle: "Massgeschneiderte Software, Cybersicherheit und exklusive Mobilität. Wählen Sie Ihr Universum.",
      it: {
        label: "Bereich 01 — Informatik",
        title: "SaaS & Cybersicherheit",
        desc: "Massgeschneiderte Softwareentwicklung, Sicherheitsaudits und Penetrationstests nach Schweizer Standards.",
        cta: "IT-Bereich entdecken",
        tags: ["SaaS-Entwicklung", "Pentest", "SOC 24/7"],
      },
      transport: {
        label: "Bereich 02 — Transport",
        title: "VIP-Transport & Fahrzeuge",
        desc: "Exklusiver Chauffeurservice, Prestige-Mietwagen sowie An- & Verkauf von Premium-Fahrzeugen.",
        cta: "Transport-Bereich entdecken",
        tags: ["Chauffeurservice", "Miete", "An- & Verkauf"],
      },
      marquee: ["GENF", "ZÜRICH", "SAAS", "CYBERSICHERHEIT", "CHAUFFEURSERVICE", "PENTEST", "PRESTIGE-MIETE", "GSTAAD", "ST. MORITZ", "LAUSANNE"],
      aboutEyebrow: "Über uns",
      aboutTitle: "Ein Schweizer Haus, zwei aussergewöhnliche Expertisen",
      aboutText: "Mit Sitz in Genf vereint iTranspro Sàrl zwei exzellente Kompetenzen: Software-Engineering und Cybersicherheit einerseits, Personentransport und Prestige-Automobile andererseits. Ein gemeinsamer Anspruch: Schweizer Präzision, Diskretion und Servicequalität.",
      stats: [
        { v: "24h", l: "Antwortzeit" },
        { v: "2", l: "Kompetenzbereiche" },
        { v: "100%", l: "Schweizer Vertraulichkeit" },
      ],
      aboutCta: "Projekt besprechen",
    },
    it: {
      badge: "Bereich 01 — Informatik",
      hero1: "Software.",
      hero2: "Sicherheit. Präzision.",
      heroSub: "Wir entwickeln und betreiben massgeschneiderte SaaS-Lösungen und sichern Ihre Systeme: Audits, Penetrationstests und kontinuierliche Überwachung nach Schweizer Standards.",
      heroCta: "Projekt schätzen",
      heroCtaSecondary: "Unsere Expertisen",
      stats: [
        { v: "3", l: "SaaS-Lösungen in Produktion" },
        { v: "24/7", l: "Garantierte Verfügbarkeit" },
        { v: "100%", l: "Massgeschneidert" },
      ],
      refTitle: "Von uns entwickelte Lösungen",
      refSub: "Drei SaaS-Plattformen, die wir entwickelt haben und täglich betreiben.",
      refs: [
        { name: "appel247.com", d: "SaaS-Plattform für intelligenten 24/7-Telefonempfang: Anrufe, Buchungen, Bestellungen und Zahlungen, automatisiert per KI.", url: "https://appel247.com" },
        { name: "noomadz.com", d: "Reiseplattform: Unterkünfte und Fahrzeugmiete mit massgeschneiderter Routenplanung.", url: "https://noomadz.com" },
        { name: "noorelbayen.com", d: "Bildungsplattform zum Koranstudium im Kontext: Suren, Hadithe und belegte historische Chronologien.", url: "https://noorelbayen.com" },
      ],
      refVisit: "Website besuchen",
      servicesTitle: "Unsere Expertisen",
      servicesSub: "Vom Code bis zum SOC: eine vollständige Wertschöpfungskette.",
      services: [
        { t: "Massgeschneiderte SaaS-Entwicklung", d: "Resiliente Cloud-Architekturen, leistungsstarke REST/GraphQL-APIs und Betrieb Ihrer Anwendungen im SaaS-Modell.", tags: ["Cloud", "API", "DevOps"] },
        { t: "Audits & Pentesting", d: "Web-, Mobile- und Netzwerk-Penetrationstests durch zertifizierte Experten, OWASP-konform.", tags: ["Red Team", "OWASP", "OSINT"] },
        { t: "Arbeitnehmerüberlassung & Entwickler-Vermittlung", d: "Wir stellen Unternehmen unsere erfahrenen Entwickler zur Verstärkung Ihrer Teams zur Verfügung — im Einsatz oder in der Arbeitnehmerüberlassung: Rekrutierung, Administration und Schweizer Konformität inklusive.", tags: ["Staffing", "Einsatz", "Rekrutierung"] },
        { t: "Überwachung & SOC 24/7", d: "Echtzeit-Überwachung Ihrer Infrastrukturen mit Erkennung und Reaktion auf Vorfälle.", tags: ["SIEM", "Monitoring", "Response"] },
        { t: "DSG & DSGVO-Compliance", d: "Begleitung zur Konformität von Banken-, Gesundheits- und Personendaten nach Schweizer und EU-Recht.", tags: ["DSG", "DSGVO", "ISO 27001"] },
      ],
      terminal: [
        "$ nmap -sS --top-ports 1000 ziel.ch",
        "[+] 443/tcp open  https",
        "$ ./pentest --scope webapp --mode stealth",
        "[+] Schwachstelle erkannt — Endpoint /api/v1/users",
        "[+] Bericht erstellt: Kritikalität HOCH",
        "$ DSG-Konformität: OK",
      ],
      estimator: {
        title: "Projekt-Schätzer",
        desc: "Erhalten Sie eine erste Budget- und Zeitspanne für Ihr Projekt.",
        serviceLabel: "Art der Leistung",
        services: ["Web-Pentest (Applikation)", "Infrastruktur-Pentest", "Massgeschneiderte SaaS-Entwicklung", "Audit & Compliance ISO 27001 / DSG"],
        scopeLabel: "Umfang — Applikationen / IPs",
        unit: "Elemente",
        critLabel: "Kritikalität",
        crit: ["Standard", "Hoch", "Kritisch — Banken / Gesundheit"],
        result: "Unverbindliche Schätzung",
        weeks: "Wochen",
        note: "Unverbindliche Schätzung — wird nach Analyse Ihrer Anforderungen präzisiert.",
        cta: "Detaillierte Offerte anfordern",
      },
      ctaTitle: "Ihr nächstes Audit beginnt hier.",
      ctaSub: "Antwort unserer Ingenieure innert 24 Stunden.",
      ctaBtn: "Gespräch starten",
    },
    transport: {
      badge: "Bereich 02 — Transport & Fahrzeuge",
      hero1: "Die Strasse.",
      hero2: "In erster Klasse.",
      heroSub: "Exklusiver Chauffeurservice, Prestige-Mietwagen und Fahrzeugvermittlung. Aussergewöhnliche Mobilität zwischen Genf, Zürich und den Alpen.",
      cta1: "Fahrt berechnen",
      cta2: "Kontakt",
      servicesTitle: "Unsere Dienstleistungen",
      servicesSub: "Jede Fahrt, jedes Fahrzeug, jedes Detail — gemeistert.",
      services: [
        { t: "VIP-Chauffeurservice", d: "Flughafentransfers (GVA/ZRH), Kongresse und Geschäftsreisen mit diskreten Berufschauffeuren." },
        { t: "Prestige-Mietwagen", d: "AMG A 45 S, Tesla Model Y, AMG CLA und BYD Seal U DM-i — tageweise oder im Langzeit-Abo." },
        { t: "An- & Verkauf, Sourcing", d: "Vermittlung und Expertise für den Kauf oder Verkauf von Luxus- und Sammlerfahrzeugen." },
        { t: "Concierge & Flotten", d: "Firmenflotten-Management, Unterhalt und massgeschneiderte Auto-Conciergerie." },
      ],
      fleetTitle: "Unsere Mietflotte",
      fleetSub: "Vier aussergewöhnliche Fahrzeuge, gepflegt und in Genf verfügbar.",
      fleetCta: "Flotte entdecken",
      calculator: {
        title: "Fahrt- & Mietrechner",
        desc: "Ein Richtpreis in wenigen Sekunden, bestätigt bei der Buchung.",
        serviceLabel: "Leistung",
        services: ["Chauffeurservice", "Fahrzeugmiete", "An- & Verkauf / Sourcing"],
        routeLabel: "Strecke",
        routes: ["Genf Flughafen → Stadtzentrum", "Genf → Zürich", "Genf → Gstaad", "Genf → St. Moritz", "Zürich → Davos"],
        vehicleLabel: "Fahrzeug",
        vehicles: ["Mercedes-AMG A 45 S", "Tesla Model Y", "Mercedes-AMG CLA", "BYD Seal U DM-i"],
        daysLabel: "Dauer",
        days: "Tage",
        result: "Richtpreis",
        onRequest: "Auf persönliche Offerte",
        note: "Richtpreis inkl. MwSt. — wird bei Buchung bestätigt.",
        cta: "Buchen / Offerte anfordern",
      },
      ctaTitle: "Ihr Chauffeur erwartet Sie.",
      ctaSub: "Verfügbar 7/7 zwischen Genf, Zürich und den Alpenorten.",
      ctaBtn: "Jetzt buchen",
    },
    rental: {
      title: "Prestige-Mietwagen",
      sub: "Unsere eigene Flotte, sorgfältig gepflegt und in Genf verfügbar. Tageweise, wochenweise oder im Langzeit-Abo.",
      seats: "Plätze",
      auto: "Automatik",
      cta: "Dieses Fahrzeug anfragen",
      note: "Jedes Fahrzeug wird sauber, geladen oder vollgetankt übergeben, mit 7/7-Assistance. Angaben gemäss Herstellerdaten; Preise auf Offerte je nach Dauer und Saison.",
      labels: { power: "Leistung", accel: "0 → 100 km/h", drivetrain: "Antrieb", energy: "Energie / Verbrauch", gearbox: "Getriebe", trunk: "Kofferraum", seats: "Plätze" },
      cars: [
        "Kompaktsportler mit explosivem Temperament und 421 PS: die perfekte Verbindung aus Stadt-Agilität und Rennstrecken-Gefühl.",
        "Vielseitiges 100% elektrisches SUV: grosse Reichweite, geräumiger Innenraum und zukunftsweisendes Fahren.",
        "4-Türer-Coupé mit skulpturalen Linien: exekutive Eleganz und sportliche Reaktivität von AMG.",
        "Plug-in-Hybrid-SUV mit 330 PS: grosszügige Gesamtreichweite und Grand-Tourisme-Komfort.",
      ],
    },
    contact: {
      title: "Kontakt & Offerte",
      desc: "Unser Team in Genf beantwortet Ihre Anfrage innert 24 Stunden.",
      name: "Vollständiger Name / Firma",
      email: "Geschäftliche E-Mail",
      phone: "Telefon (optional)",
      pole: "Gewünschter Bereich",
      poleOptions: ["IT & Software", "Transport & Fahrzeuge", "Andere Anfrage"],
      message: "Ihre Nachricht / Projektanforderungen",
      submit: "Anfrage absenden",
      sending: "Wird gesendet…",
      success: "Ihre Anfrage wurde gesendet. Wir antworten innert 24 Stunden.",
      error: "Ein Fehler ist aufgetreten. Bitte erneut versuchen.",
      required: "Pflichtfeld",
      invalidEmail: "Ungültige E-Mail-Adresse",
      tooShort: "Nachricht zu kurz (min. 10 Zeichen)",
      infoTitle: "iTranspro Sàrl",
      addr1: "30 Rue du Mail, 1205 Genf",
      ide: "IDE: CHE-177.971.181",
      emailLabel: "contact@itranspro.ch",
      phoneLabel: "+41 78 630 66 94",
    },
    footer: {
      desc: "Technologie & Mobilität der Extraklasse — ein Schweizer Haus, zwei Kompetenzbereiche.",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      legal: "Impressum",
      privacy: "Datenschutzerklärung",
      rights: "Alle Rechte vorbehalten.",
    },
    legal: {
      title: "Impressum",
      updated: "Letzte Aktualisierung: November 2026",
      sections: [
        { h: "Herausgeber der Website", p: "iTranspro Sàrl — Gesellschaft mit beschränkter Haftung (GmbH) nach Schweizer Recht. Sitz: 30 Rue du Mail, 1205 Genf, Schweiz. IDE-Nummer: CHE-177.971.181. Kontakt: contact@itranspro.ch." },
        { h: "Zweck der Website", p: "Diese Website dient der Präsentation der Tätigkeiten der iTranspro Sàrl: Entwicklung und Betrieb von SaaS-Software, Cybersicherheitsberatung, Arbeitnehmerüberlassung und Vermittlung von Entwicklern, professioneller Personentransport sowie An- & Verkauf und Vermietung von Fahrzeugen. Sie stellt zudem ein Kontaktformular sowie rein unverbindliche Preis- und Zeitschätzer zur Verfügung." },
        { h: "Geistiges Eigentum", p: "Alle Inhalte der Website (Texte, Logo, Grafiken, Illustrationen) sind ausschliessliches Eigentum der iTranspro Sàrl oder ihrer Partner. Jede vollständige oder teilweise Vervielfältigung, Darstellung oder Nutzung ohne vorherige schriftliche Genehmigung ist untersagt." },
        { h: "Haftung", p: "Die veröffentlichten Informationen dienen nur der Orientierung; iTranspro Sàrl bemüht sich um deren Richtigkeit, kann diese jedoch nicht dauerhaft gewährleisten. Die auf der Website angezeigten Schätzungen sind unverbindlich. iTranspro Sàrl haftet nicht für direkte oder indirekte Schäden aus der Nutzung der Website." },
        { h: "Anwendbares Recht und Gerichtsstand", p: "Diese Website untersteht Schweizer Recht. Für alle Streitigkeiten im Zusammenhang mit ihrer Nutzung sind ausschliesslich die Gerichte des Kantons Genf zuständig." },
      ],
    },
    privacy: {
      title: "Datenschutzerklärung",
      updated: "Letzte Aktualisierung: November 2026",
      sections: [
        { h: "Verantwortliche Stelle", p: "iTranspro Sàrl, 30 Rue du Mail, 1205 Genf, Schweiz — IDE: CHE-177.971.181 — contact@itranspro.ch. Diese Erklärung wurde gemäss dem Bundesgesetz über den Datenschutz (DSG) erstellt." },
        { h: "Erhobene Daten", p: "Bei Nutzung des Kontaktformulars: Name, E-Mail-Adresse, Telefonnummer (freiwillig), gewünschter Bereich und Inhalt der Nachricht. Technische Navigationsdaten (IP-Adresse, Browsertyp) können zur Gewährleistung der Sicherheit der Website verarbeitet werden." },
        { h: "Zwecke und Rechtsgrundlage", p: "Ihre Daten werden ausschliesslich zur Beantwortung Ihrer Anfragen, zur Erstellung von Offerten und zur Pflege der Geschäftsbeziehung verwendet (vorvertragliche Massnahmen und berechtigtes Interesse). Sie werden niemals verkauft oder zu Marketingzwecken weitergegeben." },
        { h: "Aufbewahrungsdauer", p: "Ihre Daten werden so lange aufbewahrt, wie es für die Bearbeitung Ihrer Anfrage erforderlich ist, danach höchstens 24 Monate ohne Geschäftsbeziehung, sofern keine gesetzliche Pflicht entgegensteht." },
        { h: "Empfänger und Übermittlungen", p: "Die Daten werden in der Schweiz und gegebenenfalls in der Europäischen Union durch unsere technischen Auftragsbearbeiter (Hosting, E-Mail-Versand) verarbeitet, die an Vertraulichkeits- und Sicherheitspflichten gebunden sind." },
        { h: "Ihre Rechte", p: "Gemäss DSG haben Sie ein Recht auf Auskunft, Berichtigung, Löschung und Widerspruch betreffend Ihre Daten. Schreiben Sie an contact@itranspro.ch. Sie können sich zudem an den Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) wenden." },
        { h: "Sicherheit", p: "Wir treffen angemessene technische und organisatorische Massnahmen (TLS-Verschlüsselung, eingeschränkter Zugriff), um Ihre Daten vor unbefugtem Zugriff zu schützen." },
      ],
    },
  },
  en: {
    common: {
      brand: "iTranspro",
      tagline: "Swiss excellence at the intersection of technology and mobility",
      guarantee: "Registered Swiss enterprise — Confidential & Certified",
    },
    nav: { home: "Home", it: "IT & Software", transport: "Transport & Vehicles", contact: "Contact & Quote" },
    home: {
      eyebrow: "iTranspro Sàrl — Geneva",
      title1: "Two worlds.",
      title2: "One Swiss standard.",
      subtitle: "Bespoke software, cybersecurity and exceptional mobility. Choose your universe.",
      it: {
        label: "Division 01 — IT",
        title: "SaaS & Cybersecurity",
        desc: "Bespoke software development, security audits and penetration testing to Swiss standards.",
        cta: "Explore IT division",
        tags: ["SaaS Development", "Pentest", "SOC 24/7"],
      },
      transport: {
        label: "Division 02 — Transport",
        title: "VIP Transport & Vehicles",
        desc: "Executive private chauffeur, prestige rental and high-end vehicle sales & sourcing.",
        cta: "Explore Transport division",
        tags: ["Private Chauffeur", "Rental", "Sales & Sourcing"],
      },
      marquee: ["GENEVA", "ZURICH", "SAAS", "CYBERSECURITY", "PRIVATE CHAUFFEUR", "PENTEST", "PRESTIGE RENTAL", "GSTAAD", "ST. MORITZ", "LAUSANNE"],
      aboutEyebrow: "About us",
      aboutTitle: "One Swiss house, two exceptional expertises",
      aboutText: "Based in Geneva, iTranspro Sàrl brings together two fields of excellence: software engineering & cybersecurity on one side, executive transport & prestige automotive on the other. One shared standard: Swiss precision, discretion and service quality.",
      stats: [
        { v: "24h", l: "Response time" },
        { v: "2", l: "Areas of expertise" },
        { v: "100%", l: "Swiss confidentiality" },
      ],
      aboutCta: "Discuss your project",
    },
    it: {
      badge: "Division 01 — IT",
      hero1: "Software.",
      hero2: "Security. Precision.",
      heroSub: "We design and operate bespoke SaaS solutions and secure your systems: audits, penetration testing and continuous monitoring, to Swiss standards.",
      heroCta: "Estimate a project",
      heroCtaSecondary: "Our expertise",
      stats: [
        { v: "3", l: "SaaS solutions in production" },
        { v: "24/7", l: "Availability ensured" },
        { v: "100%", l: "Bespoke" },
      ],
      refTitle: "Solutions built by us",
      refSub: "Three SaaS platforms we developed and operate every day.",
      refs: [
        { name: "appel247.com", d: "SaaS platform for intelligent 24/7 call answering: calls, bookings, orders and payments automated by AI.", url: "https://appel247.com" },
        { name: "noomadz.com", d: "Travel platform: accommodation and vehicle rentals with bespoke itinerary planning.", url: "https://noomadz.com" },
        { name: "noorelbayen.com", d: "Educational platform for contextual Quran study: surahs, hadiths and sourced historical timelines.", url: "https://noorelbayen.com" },
      ],
      refVisit: "Visit website",
      servicesTitle: "Our expertise",
      servicesSub: "From code to SOC: a complete value chain.",
      services: [
        { t: "Bespoke SaaS Development", d: "Resilient cloud architectures, high-throughput REST/GraphQL APIs and operation of your applications as a service.", tags: ["Cloud", "API", "DevOps"] },
        { t: "Audits & Pentesting", d: "Web, mobile and network penetration tests by certified experts, aligned with OWASP.", tags: ["Red Team", "OWASP", "OSINT"] },
        { t: "Staff Leasing & Developer Placement", d: "We provide companies with our experienced developers to strengthen your teams — on assignment or via staff leasing: recruitment, administration and Swiss compliance taken care of.", tags: ["Staffing", "On-site", "Recruitment"] },
        { t: "Monitoring & SOC 24/7", d: "Real-time infrastructure monitoring with intrusion detection and incident response.", tags: ["SIEM", "Monitoring", "Response"] },
        { t: "FADP & GDPR Compliance", d: "Guidance towards compliance of banking, medical and personal data under Swiss and EU law.", tags: ["FADP", "GDPR", "ISO 27001"] },
      ],
      terminal: [
        "$ nmap -sS --top-ports 1000 target.ch",
        "[+] 443/tcp open  https",
        "$ ./pentest --scope webapp --mode stealth",
        "[+] Vulnerability found — endpoint /api/v1/users",
        "[+] Report generated: severity HIGH",
        "$ FADP compliance: OK",
      ],
      estimator: {
        title: "Project Estimator",
        desc: "Get a first budget and timeline range for your project.",
        serviceLabel: "Type of engagement",
        services: ["Web application pentest", "Infrastructure pentest", "Bespoke SaaS development", "ISO 27001 / FADP compliance audit"],
        scopeLabel: "Scope — applications / IPs",
        unit: "items",
        critLabel: "Criticality",
        crit: ["Standard", "High", "Critical — banking / health"],
        result: "Indicative estimate",
        weeks: "weeks",
        note: "Non-binding estimate — refined after reviewing your requirements.",
        cta: "Request a detailed quote",
      },
      ctaTitle: "Your next audit starts here.",
      ctaSub: "Our engineers reply within 24 business hours.",
      ctaBtn: "Start the conversation",
    },
    transport: {
      badge: "Division 02 — Transport & Vehicles",
      hero1: "The road.",
      hero2: "In first class.",
      heroSub: "Executive private chauffeur, prestige vehicle rental and automotive brokerage. Exceptional mobility between Geneva, Zurich and the Alps.",
      cta1: "Calculate a ride",
      cta2: "Contact us",
      servicesTitle: "Our services",
      servicesSub: "Every journey, every vehicle, every detail — mastered.",
      services: [
        { t: "VIP Private Chauffeur", d: "Airport transfers (GVA/ZRH), congresses and business travel with discreet professional drivers." },
        { t: "Prestige Rental", d: "AMG A 45 S, Tesla Model Y, AMG CLA and BYD Seal U DM-i — by the day or long-term." },
        { t: "Sales & Sourcing", d: "Brokerage and expertise for acquiring or selling luxury and collector cars." },
        { t: "Concierge & Fleets", d: "Corporate fleet management, maintenance and bespoke automotive concierge." },
      ],
      fleetTitle: "Our rental fleet",
      fleetSub: "Four exceptional vehicles, meticulously maintained and available in Geneva.",
      fleetCta: "Discover the fleet",
      calculator: {
        title: "Ride & Rental Calculator",
        desc: "An indicative fare in seconds, confirmed at booking.",
        serviceLabel: "Service",
        services: ["Private chauffeur", "Vehicle rental", "Sales / sourcing"],
        routeLabel: "Route",
        routes: ["Geneva Airport → City centre", "Geneva → Zurich", "Geneva → Gstaad", "Geneva → St. Moritz", "Zurich → Davos"],
        vehicleLabel: "Vehicle",
        vehicles: ["Mercedes-AMG A 45 S", "Tesla Model Y", "Mercedes-AMG CLA", "BYD Seal U DM-i"],
        daysLabel: "Duration",
        days: "days",
        result: "Indicative fare",
        onRequest: "On personalised quote",
        note: "Indicative fare incl. VAT — confirmed at booking.",
        cta: "Book / request a quote",
      },
      ctaTitle: "Your chauffeur awaits.",
      ctaSub: "Available 7/7 between Geneva, Zurich and the alpine resorts.",
      ctaBtn: "Book now",
    },
    rental: {
      title: "Prestige Rental",
      sub: "Our own fleet, meticulously maintained and available in Geneva. By the day, by the week or long-term.",
      seats: "seats",
      auto: "Automatic",
      cta: "Enquire about this vehicle",
      note: "Every vehicle is handed over clean, charged or fully fueled, with 7/7 assistance. Specifications per manufacturer data; rates on quote depending on duration and season.",
      labels: { power: "Power", accel: "0 → 100 km/h", drivetrain: "Drivetrain", energy: "Energy / consumption", gearbox: "Gearbox", trunk: "Boot", seats: "Seats" },
      cars: [
        "Compact with an explosive 421 hp temperament: the perfect blend of urban agility and track sensations.",
        "Versatile 100% electric SUV: long range, spacious cabin and cutting-edge driving experience.",
        "4-door coupé with sculptural lines: executive elegance and sporty AMG responsiveness.",
        "330 hp plug-in hybrid SUV: generous combined range and grand-touring comfort.",
      ],
    },
    contact: {
      title: "Contact & Quote",
      desc: "Our Geneva office responds to your requirements within 24 business hours.",
      name: "Full name / company",
      email: "Work email address",
      phone: "Phone (optional)",
      pole: "Relevant division",
      poleOptions: ["IT & Software", "Transport & Vehicles", "Other inquiry"],
      message: "Your message / project specifications",
      submit: "Submit request",
      sending: "Sending…",
      success: "Your request has been sent. We reply within 24 hours.",
      error: "Something went wrong. Please try again.",
      required: "This field is required",
      invalidEmail: "Invalid email address",
      tooShort: "Message too short (min. 10 characters)",
      infoTitle: "iTranspro Sàrl",
      addr1: "30 Rue du Mail, 1205 Geneva",
      ide: "IDE: CHE-177.971.181",
      emailLabel: "contact@itranspro.ch",
      phoneLabel: "+41 78 630 66 94",
    },
    footer: {
      desc: "Exceptional technology & mobility — one Swiss house, two areas of expertise.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legal: "Legal notice",
      privacy: "Privacy policy",
      rights: "All rights reserved.",
    },
    legal: {
      title: "Legal Notice",
      updated: "Last updated: November 2026",
      sections: [
        { h: "Site publisher", p: "iTranspro Sàrl — a Swiss limited liability company (Sàrl / GmbH). Registered office: 30 Rue du Mail, 1205 Geneva, Switzerland. Company ID (IDE): CHE-177.971.181. Contact: contact@itranspro.ch." },
        { h: "Purpose of the site", p: "This website presents the activities of iTranspro Sàrl: SaaS software development and operation, cybersecurity consulting, IT staff leasing and developer placement, professional passenger transport, and vehicle sales and rental. It also provides a contact form and purely indicative price and timeline estimators." },
        { h: "Intellectual property", p: "All content on this site (texts, logo, graphics, illustrations) is the exclusive property of iTranspro Sàrl or its partners. Any reproduction, representation or use, in whole or in part, without prior written authorisation is prohibited." },
        { h: "Liability", p: "Information is published for guidance only; iTranspro Sàrl strives to keep it accurate but cannot guarantee this at all times. Estimates shown on the site are non-binding. iTranspro Sàrl shall not be held liable for direct or indirect damage resulting from the use of this site." },
        { h: "Applicable law and jurisdiction", p: "This site is governed by Swiss law. Any dispute relating to its use falls under the exclusive jurisdiction of the courts of the canton of Geneva." },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: November 2026",
      sections: [
        { h: "Data controller", p: "iTranspro Sàrl, 30 Rue du Mail, 1205 Geneva, Switzerland — IDE: CHE-177.971.181 — contact@itranspro.ch. This policy is established in accordance with the Swiss Federal Act on Data Protection (FADP)." },
        { h: "Data collected", p: "When using the contact form: name, email address, phone number (optional), relevant division and message content. Technical browsing data (IP address, browser type) may be processed to ensure site security." },
        { h: "Purposes and legal basis", p: "Your data is used solely to respond to your inquiries, prepare quotes and manage the business relationship (pre-contractual measures and legitimate interest). It is never sold or shared for marketing purposes." },
        { h: "Retention period", p: "Your data is kept for as long as needed to process your request, then for a maximum of 24 months in the absence of a business relationship, unless a legal obligation requires otherwise." },
        { h: "Recipients and transfers", p: "Data is processed in Switzerland and, where applicable, in the European Union by our technical processors (hosting, email delivery), who are bound by confidentiality and security obligations." },
        { h: "Your rights", p: "Under the FADP, you have the right to access, rectify, delete and object to the processing of your data. Write to contact@itranspro.ch. You may also contact the Federal Data Protection and Information Commissioner (FDPIC)." },
        { h: "Security", p: "We apply appropriate technical and organisational measures (TLS encryption, restricted access) to protect your data against unauthorised access." },
      ],
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("itranspro-lang") || "fr");
  useEffect(() => {
    localStorage.setItem("itranspro-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang] || translations.fr;
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
